<template>
    <div v-show="props.showSpinner" class="flex h-full">
        <Icon name="spinner" color="var(--color-spinner-icon)" :class="'h-8 w-8 m-auto animate-spin-fast ' + props.class" />
    </div>
</template>

<script setup>
import Icon from '@/Components/Icon.vue';

const props = defineProps({
    showSpinner: {
        type: Boolean,
        default: false
    },
    class: {
        type: String,
        default: ''
    }
})
</script>